/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MhStock } from '../../models/mh-stock';

export interface FindAll1$Params {
  page?: number;
  count?: number;
  sort?: string;
  dir?: 'ASC' | 'DESC';
  status?: 'ACTIVE' | 'INACTIVE';
}

export function findAll1(http: HttpClient, rootUrl: string, params?: FindAll1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MhStock>>> {
  const rb = new RequestBuilder(rootUrl, findAll1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('count', params.count, {});
    rb.query('sort', params.sort, {});
    rb.query('dir', params.dir, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MhStock>>;
    })
  );
}

findAll1.PATH = '/api/values/stock';
